var has = require('../internals/has');
var toIndexedObject = require('../internals/to-indexed-object');
var arrayIncludes = require('../internals/array-includes');
var hiddenKeys = require('../internals/hidden-keys');

var arrayIndexOf = arrayIncludes(false);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};
